import { User } from '../types/User';

const API_BASE_URL = import.meta.env.DEV ? 'http://localhost:3000' : '';

export const getUserFromToken = async (): Promise<User | null> => {
  const token = localStorage.getItem('authToken');

  if (!token) {
    return null;
  }

  try {
    const response = await fetch(`${API_BASE_URL}/api/auth/me`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      throw new Error('Failed to validate token');
    }

    const data = await response.json();
    return data.user;
  } catch (error) {
    console.error('Error fetching user from token:', error);
    logout();
    return null;
  }
};

export const requestMagicLink = async (email: string, turnstileToken: string): Promise<void> => {
  const response = await fetch(`${API_BASE_URL}/api/auth/magic-link`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ email, turnstileToken })
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to send magic link');
  }
};

export const logout = () => {
  localStorage.removeItem('authToken');
};

export const checkAuthStatus = (): boolean => {
  return !!localStorage.getItem('authToken');
};